import React from "react";

import {
	faInfo,
	faFolder,
	faAlignLeft,
	faExclamationCircle,
} from "@fortawesome/free-solid-svg-icons";

import {
	Row,
	Col,
	Container,
} from "react-bootstrap";

import { observer } from "mobx-react";
import { withRouter } from "react-router-dom";

import {
	Card,
	Jumbotron,
} from "../common";

import {
	chunk,
	isForm,
	isRedirect,
	isParentCategory,
} from "../../util";

export const SubCategoryPage = observer(withRouter(({
	match,
	history,
	isRoot,
	controller,
}) => {

	const category = controller.getCategory(parseInt(match.params.id, 10));

	let items = chunk((category.subCategories || []), 3).map((row, index) => (
		<Row lg={3} md={2} key={index}>

			{row.map((c) => {

				let icon = faInfo;
				let onClick = () => {};

				if (isForm(c)) {
					icon = faAlignLeft;
					onClick = () => history.push(`/category/${c.parentId}/form/${c.categoryId}`);
				} else if (isRedirect(c)) {
					icon = faAlignLeft;
					onClick = () => {

						const redirect = controller.getCategory(c.redirectToId);

						if (redirect && isForm(redirect)) {
							history.push(`/category/${c.parentId}/form/${c.redirectToId}`);
						} else if (redirect && isParentCategory(redirect)) {
							history.push(`/category/${c.redirectToId}`);
						}

					};

				} else if (isParentCategory(c)) {
					icon = faFolder;
					onClick = () => history.push(`/category/${c.categoryId}`);
				}

				return (
					<Col lg={4} md={6} key={c.categoryId}>
						<Card
							title={c.title}
							description={c.description}
							icon={icon}
							onClick={onClick}
							extraInfo={c.extraInfo}
						/>
					</Col>
				);

			})}

		</Row>
	));

	if (items.length < 1) {
		items = (
			<Row>
				<Col md={{ span: 8, offset: 2 }} lg={{ span: 8, offset: 2 }}>
					<div className="portal-info">
						<h1>Information</h1>
						<p>Vi har nu lanserat den nya enklare smartportalen, så om du hamnat här behöver du rensa cache och historik i din webbläsare. <br /><br />
						Du hittar dem under inställningar i webbläsaren. Du klickar på de små prickarna längst upp till höger vid krysset som stänger fönstret. Där väljer du ”Inställningar” och sedan ”Sekretess, sökning och tjänster”. Klicka sedan på knappen ”Välj vad du vill rensa” i stycket ”Rensa webbdata”.
						OBS! Det är de bara fyra översta valen som ska vara markerade om du vill att t.ex. dina sparade lösenord ska finnas kvar.
						<br /><br />
						SOLTAK Kundservice telefonnummer 010-33 13 000
						</p>
						
					</div>
				</Col>
			</Row>
		);
	}

	return (
		<Jumbotron background={isRoot ? "main" : "sub"}>
			<Container fluid>
				{items}
			</Container>
		</Jumbotron>

	);

}));
